import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { BtnTooltipModel } from '../../../../core/models/btn.tooltip.model';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-btn-tooltip',
  templateUrl: './btn-tooltip.component.html',
  styleUrls: ['./btn-tooltip.component.scss']
})
export class BtnTooltipComponent {

  screenWidth: number;
  wideScreen: boolean;

  @Input() DATA_CONFIG: BtnTooltipModel;
  @ViewChild('tooltipButton', {static: false}) tooltipButton: ElementRef;

  /**
   * @ignore
   */
  constructor() {
    this.onResize();
   }

   /**
    * onResize
    */
  @HostListener('window:resize', ['$event'])
  onResize(): void {

    this.screenWidth = window.innerWidth;
    this.wideScreen = this.screenWidth > Numbers.number991;
  }
}
